const MenuUrls = {
  WebsiteMenusByLocation: '/WebsiteMenus/public/',
  WebsiteMenusByParent: '/WebsiteMenus/public/parent/',
  WebsiteMenusByParentAndCategory: '/WebsiteMenus/public/parent-category/',
  WebsiteMenuChildAndParent: '/WebsiteMenus/public/child-parent',
  ParentMenus: '/WebsiteMenus/parent/option-view/',
} as const;

export default MenuUrls;
